import React, { useState } from "react";
import { RiCloseFill, RiErrorWarningFill } from "react-icons/ri";

const DeleteConfirmationModal = ({ closeModal, confirmDelete, equipment }) => {
  const [hoverConfirm, setHoverConfirm] = useState(false);
  const [hoverCancel, setHoverCancel] = useState(false);

  const isMobile = window.innerWidth < 768;

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(10, 15, 25, 0.55)",
    zIndex: 1000,
    padding: 20,
  };

  const cardStyle = {
    width: "min(560px, 96%)",
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 10px 30px rgba(8, 15, 30, 0.35)",
    overflow: "hidden",
    fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
    border: "1px solid rgba(16, 24, 40, 0.05)",
  };

  const headerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "18px 20px",
    background: "linear-gradient(90deg, #0f172a 0%, #0ea5a2 100%)",
    color: "#fff",
  };

  const titleStyle = {
    margin: 0,
    fontSize: 18,
    fontWeight: 700,
    letterSpacing: "0.2px",
  };

  const closeBtnStyle = {
    background: "rgba(255,255,255,0.12)",
    border: "none",
    color: "#fff",
    width: 36,
    height: 36,
    borderRadius: 10,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 4px 10px rgba(2,6,23,0.2)",
  };

  const bodyStyle = {
    display: "flex",
    gap: 18,
    padding: isMobile ? 18 : 22,
    alignItems: isMobile ? "center" : "flex-start",
    flexDirection: isMobile ? "column" : "row",
    textAlign: isMobile ? "center" : "left",
  };

  const iconWrapStyle = {
    minWidth: 64,
    minHeight: 64,
    borderRadius: 12,
    background: "linear-gradient(180deg, rgba(255,243,224,1) 0%, rgba(255,236,179,1) 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "inset 0 -6px 14px rgba(255,176,58,0.08)",
  };

  const iconStyle = {
    color: "#b45309",
    width: 36,
    height: 36,
  };

  const contentStyle = {
    flex: 1,
    color: "#0f172a",
  };

  const messageStyle = {
    margin: 0,
    fontSize: 15,
    lineHeight: 1.4,
    color: "#0b1220",
  };

  const hintStyle = {
    marginTop: 10,
    fontSize: 13,
    color: "#475569",
  };

  const footerStyle = {
    display: "flex",
    justifyContent: "center",
    gap: 12,
    padding: "18px 22px 26px",
    flexDirection: isMobile ? "column" : "row",
    alignItems: isMobile ? "stretch" : "center",
  };

  const confirmStyle = {
    minWidth: 120,
    padding: "10px 14px",
    borderRadius: 10,
    border: "none",
    color: "#fff",
    background: hoverConfirm
      ? "linear-gradient(90deg, #059669, #10b981)"
      : "linear-gradient(90deg, #06b6d4, #10b981)",
    cursor: "pointer",
    fontWeight: 600,
    boxShadow: hoverConfirm ? "0 8px 20px rgba(6,182,139,0.18)" : "0 6px 18px rgba(16,185,129,0.12)",
    transition: "all 150ms ease",
  };

  const cancelStyle = {
    minWidth: 120,
    padding: "10px 14px",
    borderRadius: 10,
    border: "1px solid rgba(15, 23, 42, 0.08)",
    background: hoverCancel ? "#fff" : "#f8fafc",
    color: hoverCancel ? "#0b1220" : "#334155",
    cursor: "pointer",
    fontWeight: 600,
    boxShadow: hoverCancel ? "0 8px 20px rgba(15,23,42,0.06)" : "none",
    transition: "all 150ms ease",
  };

  const label = equipment === "labTestDetails"
    ? "delete this lab test detail"
    : `remove this ${equipment} from the patient`;

  return (
    <div style={overlayStyle} role="dialog" aria-modal="true" aria-label="Confirm deletion">
      <div style={cardStyle}>
        <div style={headerStyle}>
          <h3 style={titleStyle}>Confirm Action</h3>
          <button
            aria-label="Close"
            onClick={closeModal}
            style={closeBtnStyle}
          >
            <RiCloseFill size={20} />
          </button>
        </div>

        <div style={bodyStyle}>
          <div style={iconWrapStyle}>
            <RiErrorWarningFill style={iconStyle} />
          </div>

          <div style={contentStyle}>
            <p style={messageStyle}>
              Are you sure you want to {label}?
            </p>
            <p style={hintStyle}>
              This action cannot be undone. Consider reviewing related records before confirming.
            </p>
          </div>
        </div>

        <div style={footerStyle}>
          <button
            onMouseEnter={() => setHoverConfirm(true)}
            onMouseLeave={() => setHoverConfirm(false)}
            onClick={confirmDelete}
            style={confirmStyle}
          >
            Yes, delete
          </button>

          <button
            onMouseEnter={() => setHoverCancel(true)}
            onMouseLeave={() => setHoverCancel(false)}
            onClick={closeModal}
            style={cancelStyle}
          >
            No, keep it
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
